import React, { useState, useEffect } from "react";
import commonDatas  from '../../apps/CommonDatas'

import './Top.css';

import { Link } from "react-router-dom";

export function Top () {
  let isCheck = commonDatas.getCookie("check");

  const [isShowPopup, setIsShowPopup] = useState((isCheck !== "true" ));
  const [isPopupCheck, setIsPopupCheck] = useState(false);

  const onPopupCheckClick = (e) => {
    e.preventDefault();
    setIsPopupCheck(!isPopupCheck);
  }
  const onPopupCloseClick = (e) => {
    e.preventDefault();
    if( isPopupCheck ){
        commonDatas.setCookie("check", "true");
    }
    setIsShowPopup(false);
  }
  useEffect(() => {
    document.getElementsByTagName("html")[0].scrollTop = 0;
    document.body.scrollTop = 0;

    const bgmObj1 = document.getElementById("bgm1");
    const bgmObj2 = document.getElementById("bgm2");
    bgmObj1.pause();
    bgmObj1.currentTime = 0;
    bgmObj2.pause();
    bgmObj2.currentTime = 0;
  }, []);
  return (
    <>
      <div id="top" className="content_wrapper">
        <h1><img src="./images/kv.jpg" width="100%" alt="めざせ！最強！おっとっとハンター！ スマートフォンをかざして、いまだけのゲームを楽しもう！" /></h1>
        <main className="content_inner">
          <div className="mb60"><img src="./images/how_to_play.png" width="89.333%" alt="あそびかた 1.おっとっとを買う 2.生き物を選ぶ 3.選んだ生き物のシルエットをえらぶ 4.画面のフレームに菓子型をあわせる 5.生き物とフレームがはまった！ 全69種をみつけてみよう！　あそべるのは2026年12月25日(金)11時まで！ 本コンテンツは、菓子型全69種類(うすしお味限定で38種類、コンポタージュ味限定で31種類封入されております）を見つけるコンテンツとなります。すべて見つけたことでのプレゼントキャンペーンなどはございません。ご了承ください。" /></div>
          <div className="mb60"><img src="./images/txt_sound_attention.png" width="89.333%" alt="ご利用いただく際の注意 ゲーム中、マナーモードでも音声が再生されます。お使いの端末での設定ボリュームとなりますので、ご注意ください。" /></div>
          <div className="mb100"><Link to="/list" className="btn_start"><img src="./images/btn_start.png" width="80%" alt="スタート" /></Link></div>
          <div className="attention_block">
            <div className="attention_area">
              <div className="attention_header">ゲームを始める前に確認してね</div>
              <div className="attention_body">
                <div className="attention_inner">
                  <div className="attention_inner_header pt55 mb50">動作環境の確認</div>
                  <div className="pb50 ml50 mr50 left">
                    <ul>
                      <li className="infomation mb40">本コンテンツはスマートフォンのみでご利用いただけます</li>
                      <li className="infomation mb40">推奨動作環境は、Android11.0以上 <br />（Chrome）/ iOS15以上（safari）となります</li>
                      <li className="attention mb40">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</li>
                      <li className="infomation mb40">本コンテンツはCookieを使用しておりますので、菓子型収集中はCookieを削除されないようご注意ください</li>
                      <li className="infomation mb40">室内外の環境光によって認識しづらい場合がございます</li>
                      <li className="infomation mb40">割れている・欠けている菓子は形を読み取れない可能性がございます</li>
                      <li className="infomation mb40">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください</li>
                      <li className="infomation mb40">端末のカメラによっては認識しづらい場合がございます</li>
                      <li className="infomation mb40">形を読み込む際は、菓子を置いておこなってください</li>
                      <li className="infomation red">本コンテンツは2026年12月25日(金)11:00までとなります</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <footer className="content_footer">
          <div className="mb45"><img src="./images/logo.png" width="37.6%" alt="おっとっと" /></div>
          <div><img src="./images/copyright.png" width="86.133%" alt="Copyright © MORINAGA & CO., LTD. All rights reserved." /></div>
        </footer>


        {isShowPopup ? <div id="check_popup">
          <div className="popup_inner">
            <div className="check_popup_header">
              <div><img src="./images/txt_top_popup_title.png" alt="動作環境の確認" /></div>
            </div>
            <div className="check_popup_body">
              <div className="check_popup_body_inner">
                <ul>
                  <li className="infomation mb30">本コンテンツはスマートフォンのみでご利用いただけます</li>
                  <li className="infomation red mb30">推奨動作環境は、Android11.0以上<br />（Chrome）/ iOS15以上（safari）となります</li>
                  <li className="attention red mb30">推奨動作環境であっても、古い端末や一部端末、端末の設定によっては動作しない場合がございます。ご了承下さい</li>
                  <li className="infomation mb30">本コンテンツはCookieを使用しておりますので、菓子型収集中はCookieを削除されないようご注意ください</li>
                  <li className="infomation mb30">室内外の環境光によって認識しづらい場合がございます</li>
                  <li className="infomation mb30">割れている・欠けている菓子は形を読み取れない可能性がございます</li>
                  <li className="infomation mb30">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください</li>
                  <li className="infomation mb30">端末のカメラによっては認識しづらい場合がございます</li>
                  <li className="infomation mb30">形を読み込む際は、菓子を置いておこなってください</li>
                  <li className="infomation">本コンテンツは2026年12月25日(金)11:00までとなります</li>
                </ul>
              </div>
              <div className="mb30 check_line">
                <div className="clear">
                  <a id="btn_popup_check" href="/#" onClick={(e) => onPopupCheckClick(e)}><img id="img_popup_check" src={isPopupCheck ? "./images/btn_check_on.png" : "./images/btn_check_off.png"} width="8.333%" alt="" /><img src="./images/txt_top_popup3.png" width="50%" alt="次回以降表示しない" /></a>
                </div>
              </div>
              <div className="pb50"><a id="close_check_popup" href="/#" onClick={(e) => onPopupCloseClick(e)}><img src="./images/btn_popup_close.png" width="78.525%" alt="閉じる" /></a></div>
            </div>
          </div>
        </div> : null }
      </div>
    </>
  );
};